// Basics
import { auth } from "../firebase";
import { useNavigate, Route, Routes } from "react-router-dom";
import { useEffect } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useState } from 'react';


// Me
import ButtonAppBar from "./ButtonAppBar";
import BasicTable from "./Table";
import DcoTable from "./DcoTable";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import { getUserDoc } from '../firebase';


function Dashboard({ themeMode, onToggleTheme }) {
  const [user, loading] = useAuthState(auth);

  const [accountDetails, setAccountDetails] = useState(
    {
      name: "",
      email: "",
      accounts: [],
    }
  );

  const fetchUserDoc = async () => {
    const userData = await getUserDoc();
    setAccountDetails(userData);
  }
  useEffect(() => {
    if (user) {
      fetchUserDoc();
    }
  }, [user]);

  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (!user) navigate("/");
  }, [user, loading, navigate]);

  if (loading) return null;

  return (
    <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      <ButtonAppBar accountDetails={accountDetails} themeMode={themeMode} onToggleTheme={onToggleTheme}/>
      <Container maxWidth="xl" sx={{ mt: 2, mb: 2, flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        <Routes>
          <Route exact path="/" element={<BasicTable accountDetails={accountDetails}/>} />
          <Route exact path="/dco" element={<DcoTable accountDetails={accountDetails}/>} />
        </Routes>
      </Container>
    </Box>
  );
}

export default Dashboard;
